<h3 align="center">DE CIFRIS TRENDS IN CRYPTOGRAPHIC PROTOCOLS</h3>
<p>
	The research activity carried out within the Italian cryptographic community, both in the academic field and in the
	world of work and business, has recently given rise to the association of social promotion De Componendis Cifris.
</p>
<p>
	Among the many purposes of the association, there is support for the study and research in cryptography; therefore,
	it also promotes and coordinates educational and dissemination activities at a national level. With this in mind,
	the association promotes the course Trends in
	Cryptographic Protocols, which involves ten lecturers from Italian and foreign universities and research centers (a
	<a routerLink="/trends22">similar course</a> was held last year).
</p>
<p>
	This course discloses methods and techniques used in creating modern cryptographic protocols. Based on these
	protocols, telecommunications and information systems can nowadays enjoy the peak of cryptography developments.
</p>
<p>
	The course is particularly well suited for MSC students interested in cryptography. However, anyone familiar with
	standard cryptography and its mathematical background can attend this course, including Ph.D. students, MSC
	graduates, and professionals working for companies or for the public sector.
</p>
<!-- img style="width: 40vw" src="../../../assets/attivita/Trends23/locandina-Trends-23.png" 
			class="rounded mx-auto d-block" alt="..."-->
<br>
<hr id="info">
<div class="row">
	<div class="col-md-12">
		<h3>GENERAL INFORMATIONS</h3>
		<h5>Organizers</h5>
		<p>
			Massimiliano Sala (UNITN) and Riccardo Longo (FBK).
		</p>
		<h5>Lecturers</h5>
		<p>
			Carlo Blundo (University of Salerno), Michele Ciampi (University of Edinburgh), Dario Fiore (IMDEA Software
			Institute), Barbara Masucci (University of Salerno), Claudio Orlandi (Aarhus University), Elizabeth Quaglia
			(University of London Royal Holloway), Alessandra Scafuro (North Carolina State University), Riccardo Longo
			(FBK), Luisa Siniscalchi (Technical University of Denmark), Daniele Venturi (University of Rome La
			Sapienza).
		</p>
		<h5> Course structure </h5>
		<p> The course is divided into ten online lectures via the Zoom platform, each lasting thirty minutes. The
			lessons is held in English and takes place at 5:00 PM in October 2023. The lectures are recorded and
			available to all the participants of the course.</p>
		<h5> Course prerequisites </h5>
		<ul style="list-style-type:none;  padding-left: 0;">
			<li> Mathematics: basic concepts of computational complexity, elementary number theory and probability
				theory.</li>
			<li> Symmetric cryptography: basic understanding of block ciphers, stream ciphers, hash functions and MAC's.
			</li>
			<li> Public-key cryptography: DH and RSA.</li>
			<li> Protocols: some general concept on protocols, such as those necessary to understand SSL/TLS.</li>
		</ul>
		<h5> Registration and costs </h5>
		<p>
			The course is free of charge, and any De Cifris member can attend. Registration is open until 18th September
			2023 or until the maximum number of attendees (five hundred) is reached. For any further information about
			the registration, write to <a href="mailto:trends@decifris.it">trends&#64;decifris.it</a>.
		</p>
	</div>
</div>
<hr id="programma">
<div class="row">
	<div class="col-md-12">
		<h3>COURSE PROGRAM</h3>
		<table class="table table-striped">
			<thead>
				<tr>
					<th scope="col"> Date </th>
					<th scope="col"> Subject </th>
					<th scope="col"> Time </th>
					<th scope="col"> Lecturer </th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row">
						04/10
					</th>
					<td>
						Security and Composition of Cryptographic Protocols <br>
						<a href="../../../assets/attivita/Trends23/Lecture1.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/XOWFT8qoWjo?si=4vqySWSs2PIIVHv7">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Alessandra Scafuro
						<br>
						(North Carolina State University)
					</td>
				</tr>
				<tr>
					<th scope="row">
						09/10
					</th>
					<td>
						Zero-Knowledge Protocols <br>
						<a href="../../../assets/attivita/Trends23/Lecture2.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/6X-ztLbsZXM?si=ugf0zUPPnrkgKMjI">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Luisa Siniscalchi
						<br>
						(Technical University of Denmark)
					</td>
				</tr>
				<tr>
					<th scope="row">
						11/10
					</th>
					<td>
						Sigma protocols <br>
						<a href="../../../assets/attivita/Trends23/Lecture3.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/jZ-GdeGajFQ?si=fzH5JtpguJkWpesv">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Michele Ciampi
						<br>
						(University of Edinburgh)
					</td>
				</tr>
				<tr>
					<th scope="row">
						16/10
					</th>
					<td>
						Vector commitments <br>
						<a href="../../../assets/attivita/Trends23/Lecture4.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/eO3cSHZoCVY?si=36b_51TbguQ4GAxL">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Dario Fiore
						<br>
						(IMDEA Software Institute)
					</td>
				</tr>
				<tr>
					<th scope="row">
						18/10
					</th>
					<td>
						Fully Homomorphic Encryption <br>
						<a href="../../../assets/attivita/Trends23/Lecture5.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/CYmqk0a5pm0?si=FB1E5ErIuz8-3KPn">YT video</a>
					</td>
					<td>
						18:00
					</td>
					<td>
						Daniele Venturi
						<br>
						(University of Rome <em>La Sapienza</em>)
					</td>
				</tr>
				<tr>
					<th scope="row">
						23/10
					</th>
					<td>
						Threshold Cryptographic Protocols <br>
						<a href="../../../assets/attivita/Trends23/Lecture6.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/CPCr-2nMD-w?si=KTzeKjkOYI44DFV5">YT video</a>
					</td>
					<td>
						15:00
					</td>
					<td>
						Claudio Orlandi
						<br>
						(Aarhus University)
					</td>
				</tr>
				<tr>
					<th scope="row">
						25/10
					</th>
					<td>
						Private Set Intersection <br>
						<a href="../../../assets/attivita/Trends23/Lecture7.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/Yh06NAQfJOU?si=3hqy4jNVo4ifrBSj">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Carlo Blundo <br>
						(University of Salerno)
					</td>
				</tr>
				<tr>
					<th scope="row">
						30/10
					</th>
					<td>
						Hierarchical Key assignment <br>
						<a href="../../../assets/attivita/Trends23/Lecture8.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/M-_oTpHQwTU?si=W30606MkPjykPXfI">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Barbara Masucci <br>
						(University of Salerno)
					</td>
				</tr>
				<tr>
					<th scope="row">
						02/11
					</th>
					<td>
						Protocols for Peer Rating Systems <br>
						<a href="../../../assets/attivita/Trends23/Lecture9.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/HWp-KfHRvKQ?si=tEbC7HfbI8i-bhQe">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td> Elizabeth Quaglia <br>
						(University of London <em>Royal Holloway</em>)
					</td>
				</tr>
				<tr>
					<th scope="row">
						03/11
					</th>
					<td>
						Advanced Cryptography in E-Voting <br>
						<a href="../../../assets/attivita/Trends23/Lecture10.pdf" target="_blank"> Slide </a> - <a
							href="https://youtu.be/NFEzT192Pqw?si=qnDJbVmn1wjRJ6AW">YT video</a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Riccardo Longo
						<br>
						(FBK)
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<hr id="test">
<div>
	<h3> TEST </h3>
	<p>
		The participants who pass an online test on <b>January the 22nd 2023</b> will receive a &quot;Course
		Attendance&quot;
		certificate. The test consists of a written essay with personalized questions to be completed online in one
		hour.
	</p>
</div>